import { useParams } from "react-router";
import { ProductActions } from "../components/ProductActions";
import { BsQuestionCircle } from "react-icons/bs";
import { dateFormatLocal } from "../../SharedModule/utils/formatters";
import { ModalPortal } from "../../SharedModule/components/ModalPortal";
import { ModalPublish } from "../components/ModalPublish";
import { useEffect, useRef, useState } from "react";
import { useSpotlights } from "../hooks/useSpotlights";
import { Spinner } from "../../SharedModule/components/Spinner";
import { SpotlightService } from "../services/spotlight";
import { setIsSpotlightOn } from "../redux/reducers/spotlight.reducer";
import { useDispatch, useSelector } from "react-redux";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { getStatusStyle } from "../utils/spotlightUtils";
import eventHandler from "../../SharedModule/utils/eventHandler";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import image from "./../../styles/legacy/spotlight-off.png";
import { NoContent } from "../../SharedModule/components/NoContent";
import HeaderProductsModule from "../components/HeaderProductsModule";
import Footer from "../../SharedModule/components/Footer";
import { selectAuth, selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { Editor, EditorProvider } from "react-simple-wysiwyg";
import { ExternalLink } from "../../SharedModule/components/ExternalLink";

export const SpotlightPage = () => {
  let { productId } = useParams();

  const auth = useSelector(selectAuth);
  const isLogged = auth.isAuthenticated;
  const { activeUserId } = useSelector(selectUserRoles);

  const {
    lastSpotlight,
    isLoadingDataSpotlight,
    isSpotlightOn,
    isProductActive,
    isContentEditable,
    actualProductName,
  } = useSpotlights(Number(productId));

  const dispatch = useDispatch();

  const [localLoader, setLocalLoader] = useState(false);

  // Modal config
  const modalRef = useRef<undefined>(undefined);
  const showModal = () => {
    (modalRef.current as any).show(true);
  };
  const closeModal = () => {
    (modalRef.current as any).show(false);
  };

  useEffect(() => {
    dispatch(setActiveTab("spotlight"));
    document.title = "The Hub - Spotlight";
  }, []);

  const toggleSpotlight = async () => {
    setLocalLoader(true);
    let result = await SpotlightService.toggleSpotlight(Number(productId));
    if (result === "Spotlight was changed successfully.") {
      dispatch(setIsSpotlightOn(!isSpotlightOn));
      dispatch(addToast({ mode: "success", message: result }));
      eventHandler.dispatch("toast action", { isClosed: false });
    }
    setLocalLoader(false);
  };

  return (
    <>
      <ModalPortal ref={modalRef} zIndex={170}>
        <ModalPublish
          title="Update Spotlight Overview"
          btnLabel="Publish"
          btnCancelLabel="Cancel"
          btnCancel={closeModal}
          actionPlaceholder="notCloseOnClickOutside"
          type="formModal"
          lastSpotlight={lastSpotlight}
          owner={activeUserId}
        />
      </ModalPortal>
      <div className="content">
        <HeaderProductsModule
          actualProductName={actualProductName}
          isLoadingDataHeader={isLoadingDataSpotlight}
        />
        {(isLoadingDataSpotlight || localLoader) && (
          <Spinner
            style={{
              margin: "15% 45%",
            }}
          />
        )}
        {!isLoadingDataSpotlight && !localLoader && (
          <>
            <div className="content-header">
              <div className="content-header-title">
                {actualProductName} - Spotlight Overview{" "}
                {!isProductActive && (
                  <button className="btn-status">Status: Inactive</button>
                )}
              </div>
              <div className="content-header-right">
                {isLogged &&
                  isSpotlightOn &&
                  isContentEditable &&
                  isProductActive && (
                    <button
                      className="btn btn-primary me-1"
                      onClick={() => showModal()}
                    >
                      Update
                    </button>
                  )}
                <ProductActions
                  toggleHandler={toggleSpotlight}
                  isContentEditable={isContentEditable}
                  isProductActive={isProductActive}
                  isSpotlightOn={isSpotlightOn}
                  productId={productId}
                  isLogged={isLogged}
                />
              </div>
            </div>
            {isSpotlightOn && !lastSpotlight && (
              <NoContent title="No Status Yet" image={image} />
            )}
            {isSpotlightOn && lastSpotlight && (
              <div className="status-gauge-description-container">
                <div
                  className={`status-gauge ${getStatusStyle(
                    lastSpotlight?.status.id
                  )}`}
                >
                  <h5>{lastSpotlight?.status.name}</h5>
                  <ExternalLink
                    className="link-question-mark"
                    to="https://itxnet.sharepoint.com/sites/Delivery/SitePages/Spotlight-Reporting.aspx"
                  >
                    <BsQuestionCircle className="icon" />
                  </ExternalLink>
                </div>
                <div className="status-description">
                  <div className="status-author">{lastSpotlight?.fullName}</div>
                  <div className="publish-date">
                    {dateFormatLocal(lastSpotlight?.createdAt)}
                  </div>
                  <div className="status-comment">
                    <EditorProvider>
                      <Editor
                        value={lastSpotlight?.comment}
                        disabled={true}
                        containerProps={{
                          className: "hide-toolbar",
                          style: {
                            border: "none",
                            height: "auto",
                            padding: "0",
                          },
                        }}
                      />
                    </EditorProvider>
                  </div>
                </div>
              </div>
            )}
            {!isSpotlightOn && (
              <NoContent
                title="Spotlight Reporting is turned off"
                text="Turn on to include this product into the weekly spotlight reports"
                action={() => toggleSpotlight()}
                image={image}
                conditionButton={isContentEditable}
                disabledButton={!isProductActive}
                textButton="Turn On Spotlight"
              />
            )}
          </>
        )}
        <Footer />
      </div>
    </>
  );
};
